import * as React from 'react';
import BoardingPass from './BoardingPass';
import Coupon from './Coupon';
import EventTicket from './EventTicket';
import Generic from './Generic';
import StoreCard from './StoreCard';
import { usePkpass } from '../usePkpass';
export default function PassStyle() {
  const pass = usePkpass();

  switch (pass.passStyle) {
    case 'boardingPass':
      return /*#__PURE__*/React.createElement(BoardingPass, null);

    case 'coupon':
      return /*#__PURE__*/React.createElement(Coupon, null);

    case 'eventTicket':
      return /*#__PURE__*/React.createElement(EventTicket, null);

    case 'generic':
      return /*#__PURE__*/React.createElement(Generic, null);

    case 'storeCard':
      return /*#__PURE__*/React.createElement(StoreCard, null);

    default:
      return /*#__PURE__*/React.createElement("div", null, "Unsupported pass style");
  }
}
//# sourceMappingURL=PassStyle.js.map